import { render, staticRenderFns } from "./RequestRatingDetailsModal.vue?vue&type=template&id=289053c8"
import script from "./RequestRatingDetailsModal.vue?vue&type=script&lang=js"
export * from "./RequestRatingDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports